<div class="bv-linkages">
  <!-- Poderes -->
  <div class="bv-linkages__section">
    <div class="bv-linkages__section-header" (click)="toggleSection('powers')">
      <div class="bv-linkages__section-title">
        <mat-icon class="bv-linkages__chevron" [class.bv-linkages__chevron--open]="openSection === 'powers'">chevron_right</mat-icon>
        <span>{{'INDV.POWERS' | translate}}</span>
        <span class="bv-linkages__count">{{getPowersCount()}}</span>
      </div>
      @if (openSection === 'powers') {
        <mat-button-toggle-group name="viewList" class="bv-linkages__toggle"
          (change)="toggleView($event.value)" value="new"
          (click)="$event.stopPropagation()">
          <mat-button-toggle value="new">{{'INDV.VIGENTES' | translate}}</mat-button-toggle>
          <mat-button-toggle value="old">{{'INDV.NO_VIGENTES' | translate}}</mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>
    @if (openSection === 'powers') {
      <div class="bv-linkages__section-body">
        @if (getPowersLinks().length === 0) {
          <div class="bv-linkages__empty">{{'INDV.NO_LINKS' | translate}}</div>
        }
        @for (item of getPowersLinks(); track item) {
          <mat-expansion-panel class="bv-linkages__panel">
            <mat-expansion-panel-header>
              <mat-panel-title>{{item.company_name}} ({{item.total}})</mat-panel-title>
            </mat-expansion-panel-header>
            <app-table [dataSource]="item.powers" [columns]="powerTable"
              (actionClicked)="handleClick($event, 'power')"></app-table>
          </mat-expansion-panel>
        }
      </div>
    }
  </div>

  <!-- Accionistas -->
  <div class="bv-linkages__section">
    <div class="bv-linkages__section-header" (click)="toggleSection('shareholders')">
      <div class="bv-linkages__section-title">
        <mat-icon class="bv-linkages__chevron" [class.bv-linkages__chevron--open]="openSection === 'shareholders'">chevron_right</mat-icon>
        <span>{{'INDV.SHAREHOLDER' | translate}}</span>
        <span class="bv-linkages__count">{{shareholderLinks?.length || 0}}</span>
      </div>
    </div>
    @if (openSection === 'shareholders') {
      <div class="bv-linkages__section-body">
        @if (!shareholderLinks || shareholderLinks.length === 0) {
          <div class="bv-linkages__empty">{{'INDV.NO_LINKS' | translate}}</div>
        }
        @for (item of shareholderLinks; track item) {
          <mat-expansion-panel class="bv-linkages__panel">
            <mat-expansion-panel-header>
              <mat-panel-title>{{item.company_name}} ({{item.total}})</mat-panel-title>
            </mat-expansion-panel-header>
            <app-table [dataSource]="item.stocks" [columns]="shareholderTable"
              (actionClicked)="handleClick($event, 'shareholder')"></app-table>
          </mat-expansion-panel>
        }
      </div>
    }
  </div>

  <!-- Autoridades -->
  <div class="bv-linkages__section">
    <div class="bv-linkages__section-header" (click)="toggleSection('authorities')">
      <div class="bv-linkages__section-title">
        <mat-icon class="bv-linkages__chevron" [class.bv-linkages__chevron--open]="openSection === 'authorities'">chevron_right</mat-icon>
        <span>{{'INDV.AUTH' | translate}}</span>
        <span class="bv-linkages__count">{{authLinks?.length || 0}}</span>
      </div>
    </div>
    @if (openSection === 'authorities') {
      <div class="bv-linkages__section-body">
        @if (!authLinks || authLinks.length === 0) {
          <div class="bv-linkages__empty">{{'INDV.NO_LINKS' | translate}}</div>
        }
        @for (item of authLinks; track item) {
          <mat-expansion-panel class="bv-linkages__panel">
            <mat-expansion-panel-header>
              <mat-panel-title>{{item.company_name}} ({{item.total}})</mat-panel-title>
            </mat-expansion-panel-header>
            <app-table [dataSource]="item.authorities" [columns]="authTable"
              (actionClicked)="handleClick($event, 'directory')"></app-table>
          </mat-expansion-panel>
        }
      </div>
    }
  </div>

  <div class="bv-linkages__footer">
    <a class="bv-btn bv-btn--secondary" routerLink="/individuals/list">
      <mat-icon>arrow_back</mat-icon>
      {{'BUTTONS.BACK' | translate}}
    </a>
  </div>
</div>
